import { NavLink, Outlet } from 'react-router-dom';

import { SETTINGS_PAGES } from '@/layout/navigation';

/**
 * The settings area: its own sidebar of pages, the page beside it.
 *
 * Settings used to unfold inside the main sidebar as six rows at its foot,
 * which pushed Stock and everything above it off a laptop screen to make room
 * for pages visited once a month. The main sidebar now carries one Settings
 * row, and the pages are chosen here, in a second column the way the
 * reference admin lays out its settings: a list you scan top to bottom, the
 * current page lifted as the white card.
 *
 * Links, not a tablist. Each is its own route with its own address - a
 * bookmark, a link from the troubleshooting script read over the phone - so
 * they are navigation, and the current one is `aria-current="page"`, which
 * NavLink sets. On a phone the column becomes a row that scrolls sideways.
 */
export function SettingsLayout() {
  return (
    <div className="settings-layout">
      <nav className="settings-nav" aria-label="Settings">
        <span className="settings-nav-title">Settings</span>
        <div className="settings-nav-list">
          {SETTINGS_PAGES.map((page) => {
            const Icon = page.icon;
            return (
              <NavLink
                key={page.key}
                to={page.path}
                // `/settings` is also the start of every other settings path.
                end={page.path === '/settings'}
                className="settings-nav-row"
              >
                {Icon ? (
                  <span className="settings-nav-icon">
                    <Icon />
                  </span>
                ) : null}
                <span className="truncate">{page.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>

      <div className="settings-page">
        <Outlet />
      </div>
    </div>
  );
}
